// src/helpers.js

/**
 * Usuwa wszystkie undefined z obiektu lub tablicy, zamienia na null (dla Firestore).
 */
export function removeUndefinedDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeUndefinedDeep);
  } else if (obj && typeof obj === "object") {
    const out = {};
    Object.entries(obj).forEach(([k, v]) => {
      if (v === undefined) out[k] = null; // zamień undefined na null
      else out[k] = removeUndefinedDeep(v);
    });
    return out;
  }
  return obj;
}
